import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import { useSelector } from "react-redux";

import RadioSelection from "@components/common/radioSelection";
import CloneChildren from "@components/children";
import { isEmpty } from "@utils/lodash";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { CommonProps } from "@utils/interface";
import Badge, { IBadge } from "@components/common/badge";
import {
  Wrapper,
  AddonDisplayTitile,
  AddonDescription,
  AddonHighlight
} from "./styles";
import { useOnload } from "@utils/useOnLoad";
import DOMPurify from "isomorphic-dompurify";
import { analyticEvents as triggerAnalyticEvent } from "@actions/analyticEvents";
import { getRequestpayload } from "@utils/index";

interface IAddonUpgradeCard extends CommonProps {
  addonDisplayName: string;
  addonVariantDisplayName?: string;
  isSelected?: boolean;
  upgradeHighlight?: string;
  description?: string;
  addonId: string;
  variantsLength: number;
  variantModalId?: string;
  price: number;
  badge?: IBadge | null;
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const AddonUpgradeCard = ({ children, ...props }: IAddonUpgradeCard) => {
  const {
    addonDisplayName,
    addonVariantDisplayName,
    // isSelected,
    upgradeHighlight,
    description,
    actions,
    addonId,
    payloadData,
    variantsLength,
    price,
    is_visible,
    badge
  } = props;

  const { selectedPrice, selectedAddons } = useSelector(
    ({ globalState }: any) => {
      return {
        selectedAddons: globalState?.payloadData.selected_addons,
        selectedPrice: globalState?.price
      };
    }
  );

  const { on_click, on_load } = actions || {};

  const handleToggle = async (isSelected) => {
    let newPrice = selectedPrice;
    let newAddons = [...selectedAddons];
    const { data, journey } = getRequestpayload();

    if (isSelected) {
      newPrice += price;
      newAddons.push(payloadData);

      if (on_click?.[0] && typeof on_click[0].funCall === "function") {
        triggerAnalyticEvent({
          edata: {
            product: data.product,
            action_name: "tap_btn_add_on_opt_in",
            action_type: "tap_btn",
            add_on_id: addonId
          },
          odata: {
            journey
          },
          event_name: "action"
        });
        on_click[0].funCall(
          //@ts-ignore
          {
            ...on_click[0].args,
            payloadData: { selected_addons: newAddons },
            globalData: { price: newPrice }
          } || {}
        );
      }
    } else {
      newPrice -= price;
      newAddons = newAddons.filter((a) => a?.id !== addonId);
      if (on_click?.[0] && typeof on_click[0].funCall === "function") {
        triggerAnalyticEvent({
          edata: {
            product: data.product,
            action_name: "tap_btn_add_on_opt_out",
            action_type: "tap_btn",
            add_on_id: addonId
          },
          odata: {
            journey
          },
          event_name: "action"
        });
        on_click[0].funCall(
          //@ts-ignore
          {
            ...on_click[0].args,
            payloadData: { selected_addons: newAddons },
            globalData: { price: newPrice }
          } || {}
        );
      }
    }
  };

  useOnload({ on_load });

  return is_visible ? (
    <Wrapper
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {badge?.text && (
        <Badge
          text={badge.text}
          type={badge.type}
          is_visible={true}
          styles={{ marginBottom: "0.5rem" }}
        />
      )}
      <Flex style={{ justifyContent: "space-between", alignItems: "center" }}>
        <AddonDisplayTitile>
          {variantsLength && variantsLength > 0
            ? addonVariantDisplayName
            : addonDisplayName}
        </AddonDisplayTitile>
        <RadioSelection
          clickHandler={(isSelected) => {
            handleToggle(isSelected);
          }}
          selected={!isEmpty(selectedAddons?.find((a) => a.id === addonId))}
        />
      </Flex>
      <AddonHighlight>{upgradeHighlight}</AddonHighlight>
      {description && (
        <AddonDescription
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(description)
          }}
        />
      )}

      <CloneChildren children={children} props={props} />
    </Wrapper>
  ) : null;
};

export default connect(mapStateToProps)(AddonUpgradeCard);
